export var link = function () {

	//-----------------------------------------------------
	// -- 電話番号のリンク
	//-----------------------------------------------------
	$('a[href^="tel:"]').css('cursor', 'default').click(function (event) {
		if ($('html').hasClass('desktop')) {
			event.preventDefault();
		}
	});


	$('a[href^="#"]').click(function(){
		var speed = 500;
		var href= $(this).attr("href");
		var target = $(href == '#' || href == "" ? 'html' : href);
			var position = target.offset().top - 100;
			$("html, body").animate({scrollTop:position}, speed, "swing");
			if ($(document).width() < 899) {
				$('.menu_btn').removeClass('active');
				$('.scroll_header').removeAttr('style');
				$('.scroll_header').find('.block__list-btn').slideUp(200);
			}
		return false;
	});

};